export default function (trigger) {
  if (trigger) {
    trigger.addEventListener('click', function() {
      let formControl = this.closest('.js-form-group');
      if (formControl) {
        let close = formControl.querySelector('.js-tooltip__close');
        if (formControl.classList.contains('form-group--has-visible-tooltip')) {
          formControl.classList.remove('form-group--has-visible-tooltip');
          close.setAttribute('inert', 'inert');
        } else {
          formControl.classList.add('form-group--has-visible-tooltip');
          close.removeAttribute('inert');
          close.addEventListener('click', function() {
            formControl.classList.remove('form-group--has-visible-tooltip');
          });
        }
      }
    });
  }
}
